import Vue from 'vue';
import Vuex from 'vuex';

import alert from './modules/alert';
import user from './modules/user';
import toggle from './modules/toggle';

Vue.use(Vuex);

const obj = {};
const alreadyGoneModules = [];

require.context('_modules', true, /store\.js$/).keys().forEach(key => {
  const path = key.replace('./', '');
  const newpath = path.replace('/store.js', '');
  const entries = newpath.split('/').filter(e => !alreadyGoneModules.includes(e));
  const module = entries.pop();
  // eslint-disable-next-line
  obj[module] = require(`_modules/${path}`).default;
  alreadyGoneModules.push(module);
});

const store = new Vuex.Store({
  modules: Object.assign({
    user,
    alert,
    toggle,
  }, obj),
}); // Never put the same name on modules

export default store;
